<div class="content-wrapper">
  <div class="d-flex">
    <div class="page-heading">
      <h2> Major Amendments to the Rules </h2>
    </div>
    <div class="page-heading ms-auto d-flex gap-3">
      <button 
        type="button" 
        class="btn add-common-button"  
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
          <i class="bi bi-download"></i>
          <span>Export</span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <button type="button" class="dropdown-item" (click)="downloadPDF('')">All Content</button>
        </li>
        <li *ngFor="let v of versions">
          <button 
            type="button" 
            class="dropdown-item" 
            (click)="downloadPDF(v)" 
          >Version : {{v}}</button>
        </li>
      </ul>
      <button 
        type="button" 
        class="btn add-common-button" 
        (click)="uploadPDF()"
      >
        <i class="bi bi-upload"></i>
        <span>Import</span>
      </button>
    </div>
  </div>
  <div class="row g-3" *ngIf="!isLoading">
    <div *ngFor="let section of data; let i = index"
      class="col-lg-3 col-md-4 col-sm-6 col-12 dashboard-card card-popover " id="card-popover-{{ i }}"
      title="{{section.content | summury: 50}} <span class='badge text-bg-secondary float-end' data-toggle='tooltip' data-title='version 1.0'>v{{section.version}}</span>"
      data-toggle="popover" 
      data-trigger="manual"
      [attr.data-bs-html]="true" 
      [attr.data-bs-offset]="[50,0]"
      [attr.data-bs-content]="getSubRules(section)"
      (click)="onCilck(section.id)" 
      (mouseover)="onHoverIn($event, section)" 
      (mouseleave)="onHoverOut($event)">
      <div class="dashboard-card-inner">
        <!-- <div class=""> -->
          <h4 class="dashboard-card-ttl">{{ section.title }}
          </h4>
        <!-- </div> -->
        <p class="dashboard-card-des">{{ section.content | summury : 100 }} </p>
        <span class='badge position-absolute bottom-0 end-0' data-toggle="tooltip" data-title="version 1.0">v{{section.version}}</span>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading">
    <app-loader></app-loader>
  </div>
</div>